import { Component, OnInit, ViewChild, ViewEncapsulation, Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'd3';
import 'nvd3';
import { resolve } from 'path';
// import { EventFetcherService } from './event-fetcher.service';
// import { ChartInfo } from './chart-info.model';
import * as fromApp from '../store/app.reducers';
import * as fromReport from './store/report.reducers'
import { Store } from '@ngrx/store';
declare let d3: any;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css', '../../../node_modules/nvd3/build/nv.d3.css'],
  // providers: [EventFetcherService],
  encapsulation: ViewEncapsulation.None
})

export class ReportComponent implements OnInit {


  eventForm: FormGroup;
  chartState: Observable<fromReport.State>;
 /*
  barChartSet = false;
  lineChartSet = false;
  chartType: string;

*/

  constructor(private httpClient: HttpClient,
    // private eventFetcher: EventFetcherService,
    private store: Store<fromApp.AppState>) {
    // this.chartReport = this.eventFetcher.eventReporter();
   }

  ngOnInit() {

    this.eventForm = new FormGroup({
      'uuid': new FormControl(null, Validators.required)
    });

    // this.chartReport = this.eventFetcher.eventReporter();
    this.chartState = this.store.select('charts');
    console.log( this.chartState );
  }

  onSubmit() {
    this.chartState = this.store.select('charts');

    // console.log(this.eventFetcher.fetchEventResults(this.eventForm.value.uuid));
    // this.chartState = this.eventFetcher.eventReporter();
    // this.finalReport = this.eventFetcher.eventReporter();
    // this.chartType = 'bar';



  }

}



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts